import React, { useEffect, useState } from 'react'

import { Table } from 'react-bootstrap'
import toast from 'react-hot-toast'
import { useTranslation } from 'react-i18next'
import { Link, useNavigate } from 'react-router-dom'

import { useAuth } from '../common/Auth'
import { ClientColorSquare } from '../common/ClientColorSquare'
import { fetchClients } from '../common/helpers'
import { NoRecords } from '../common/NoRecords'
import axiosClient from '../service/axiosClient'
import ClientDTO from '../types/Client'

/** A client shows under its company, or under the person when there is no company. */
function clientName(client: ClientDTO): string {
    return client.companyName?.trim()
        || [client.firstName, client.lastName].filter(Boolean).join(' ')
}

export const ClientsList = () => {
    const {t} = useTranslation()
    const [clients, setClients] = useState<ClientDTO[]>([])
    const auth = useAuth()

    function load() {
        fetchClients(true).then((data) => {
            console.log('ClientsList loaded clients:', data)
            setClients(data)
        }).catch(console.error)
    }

    useEffect(() => {
        load()
    }, [])

    async function deleteClient(id: number) {
        if (confirm(t('confirm_delete_client'))) {
            await axiosClient.delete('client/' + id)
            toast.success(t('client_deleted_success'))
            load()
        }
    }

    async function toggleClientActive(id: number, currentActive: boolean) {
        const confirmMsg = currentActive ? t('confirm_deactivate_client') : t('confirm_activate_client')
        if (confirm(confirmMsg)) {
            await axiosClient.put('client/' + id + '/toggle-active')
            toast.success(currentActive ? t('client_deactivated_success') : t('client_activated_success'))
            load()
        }
    }

    return (
        // clients.length === 0 ?
        //     <NoRecords/> :
            <>
                <Table className={'fndt_table'} responsive>
                    <thead>
                    <tr>
                        {/*<th scope="col">#</th>*/}
                        <th scope="col">{t('full_name')}</th>
                        <th scope="col">{t('company_name')}</th>
                        <th scope="col">{t('mobile')}</th>
                        <th scope="col">{t('email')}</th>
                        <th scope="col" className="text-right">{t('action')}</th>
                    </tr>
                    </thead>
                    <tbody>
                    {clients.length ?
                    [...clients].sort((a, b) => {
                        // Default client always first
                        if (a.id === auth.user?.defaultClientId) return -1
                        if (b.id === auth.user?.defaultClientId) return 1
                        return 0
                    }).map((client, index) => {
                        const isDefaultClient = client.id === auth.user?.defaultClientId
                        console.log('Rendering client:', client.id, client.firstName, 'active:', client.active)
                        return (
                        <tr
                            className={client.active === false ? 'text-muted' : ''}
                            style={{
                                ...(client.active === false ? { opacity: 0.6 } : {}),
                                ...(isDefaultClient ? { backgroundColor: 'rgba(var(--bs-primary-rgb), 0.1)' } : {})
                            }}
                            key={client.id}
                            onClick={() => {
                                // navigate('/clients/' + client.id)
                            }}
                        >
                            {/*<td>{client.id}</td>*/}
                            <td><ClientColorSquare
                                color={client.color}/>{client.firstName && client.lastName ? client.firstName + ' ' + client.lastName : client.companyName}
                                {isDefaultClient && <span className="badge bg-warning text-dark ms-2">{t('my_profile_badge')}</span>}
                                {client.active === false && <span className="badge bg-secondary ms-2">{t('inactive')}</span>}
                            </td>
                            <td>
                                {client.companyName}
                            </td>
                            <td>{`${client.countryPrefix} ${client.phoneNumber} ` + (client.companyPhoneNumber ? `${client.companyCountryPrefix} ${client.companyPhoneNumber} ` : '')}</td>
                            <td>{client.email || client.companyEmail}</td>
                            <td className="text-right">
                                <div className="d-flex gap-2 justify-content-end">
                                    {client.active !== false && (
                                        <Link className={'table-action-link'} to={'/app/clients/' + client.id + '?name=' + encodeURIComponent(clientName(client))}
                                              title={t('edit')}>
                                            <i className="bi bi-pencil primary-text-color"></i>
                                        </Link>
                                    )}
                                    {auth.user?.defaultClientId !== client.id && (
                                        <a className={'table-action-link'} href={'#'} onClick={(e) => {
                                            e.preventDefault()
                                            client.id && toggleClientActive(client.id, client.active !== false)
                                        }} title={client.active === false ? t('activate') : t('deactivate')}>
                                            <i className={`bi ${client.active === false ? 'bi-toggle-off' : 'bi-toggle-on'} primary-text-color`}></i>
                                        </a>
                                    )}
                                    {auth.user?.defaultClientId !== client.id && (
                                        <a className={'table-action-link'} href={'#'} onClick={(e) => {
                                            e.preventDefault()
                                            client.id && deleteClient(client.id)
                                        }} title={t('delete')}>
                                            <i className="bi bi-trash primary-text-color"></i>
                                        </a>
                                    )}
                                </div>
                            </td>
                        </tr>
                    )}) : <tr><td colSpan={5}><NoRecords /></td></tr>}
                    </tbody>
                </Table>
                <div className="d-flex justify-content-between fndt_pagination_wrapper"></div>
            </>
    )
}